import { IChainConfig } from '../config/chains'
import { Select } from 'antd'
import { ReactNode } from 'react'

export interface ISelectChainProps {
  defaultValue?: string
  chains: IChainConfig[]
  className?: string
  style?: any
  suffixIcon?: ReactNode
  onChange: (chain: any) => Promise<void>
}

export const SelectChain = ({
  defaultValue = 'CONNECT',
  chains,
  className,
  style,
  suffixIcon,
  onChange
}: ISelectChainProps): JSX.Element => {
  return (
    <Select size="large"
            onChange={onChange} showArrow
            value={defaultValue}
            className={className}
            popupClassName={'dropdown-chain-select'}
            style={style}
            suffixIcon={suffixIcon}>
      {chains.map((chain, index) => {
        return (
          <Select.Option key={index} value={chain.chainId}>{chain.chainName}</Select.Option>
        )
      })}
    </Select>
  )
}
